'use client';

import { create } from 'zustand';

interface NewsStockIdStoreState {
  aiWinnerStockId?: string;
  aiWinnerUrl?: string;
  aiWinnerStockName?: string;
}

interface NewsStockIdStoreActions {
  setAiWinnerData: (data: NewsStockIdStoreState) => void;
}

type NewsStockIdStore = NewsStockIdStoreState & NewsStockIdStoreActions;

export const useNewsStockIdStore = create<NewsStockIdStore>(set => ({
  aiWinnerStockId: undefined,
  aiWinnerUrl: undefined,
  aiWinnerStockName: undefined,
  setAiWinnerData: data => set(data)
}));
